import React from 'react';

export default function SingleSelectWithOther() {
  return (
    <React.Fragment>
      It's a Single Select with an Other!
    </React.Fragment>
  );
}
